import { getAxiosObject } from '@/utils/library'
import {
  commonGetters,
  commonMutations,
  commonActions
} from '@/store/store_utils'

const dataName = 'analytics'

const state = {
  analytics: [],
  dataIndexedById: {},
  updatedAt: '20101010101010'
}

const getters = {
  ...commonGetters(
    dataName,
    ['getData', 'getDataById', 'getUpdatedAt', 'selectData', 'selectDataZero'],
    { filterDel: true }
  )
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async create({ commit }, analytics) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.post('/analytics', { analytics })
      if (res.status === 200) {
        commit('updateAfter', [res.data.analytics])
        return { result: true, analytics: res.data.analytics }
      }
    } catch (error) {
      return error.response?.data?.message || 'server error'
    }
  },
  async update({ commit }, analytics) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put('/analytics', { analytics })
      if (res.status === 200) {
        commit('updateAfter', [res.data.analytics])
        return { result: true, analytics: res.data.analytics }
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response?.data?.extra?.data) {
          commit('setData', error.response.data.extra.data)
        }
        return error.response.data.message
      } else {
        return 'server error'
      }
    }
  },
  async delete({ commit }, id) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.delete('/analytics', { data: { id } })
      if (res.status === 200) {
        commit('updateAfter', [res.data.analytics])
        return true
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response?.data?.extra?.data) {
          commit('setData', error.response.data.extra.data)
        }
        return error.response.data.message
      } else {
        return 'server error'
      }
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {
    indexedById: true,
    jsonColumns: ['conditions']
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
